const st = window.localStorage

export const getSession = function (key) {
  const ssVal = st.getItem(key)
  if (ssVal && ssVal.indexOf('autostringify-') === 0) {
    return JSON.parse(ssVal.split('autostringify-')[1])
  } else {
    return ssVal
  }
}

export const setSession = function (key, value) {
  if (typeof value === 'undefined') return false
  if (typeof value !== 'string') {
    value = 'autostringify-' + JSON.stringify(value)
  }
  return st.setItem(key, value)
}

export const removeSession = function (key) {
  return st.removeItem(key)
}
